module.exports = __webpack_public_path__ + "static/media/linear regression_supported.b509637c.png";